import { useEffect } from "react";
import Lenis from "lenis";
import Nav from "./components/baba/Nav";
import Hero from "./components/baba/Hero";
import Marquee from "./components/baba/Marquee";
import Categories from "./components/baba/Categories";
import Pillars from "./components/baba/Pillars";
import Visit from "./components/baba/Visit";
import Footer from "./components/baba/Footer";
import WhatsAppFloat from "./components/baba/WhatsAppFloat";
import "./App.css";

const GRAIN =
    "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/%3E%3C/filter%3E%3Crect width='180' height='180' filter='url(%23n)' opacity='0.55'/%3E%3C/svg%3E\")";

const Grain = () => (
    <div
        aria-hidden="true"
        className="pointer-events-none fixed inset-0 z-[70] opacity-[0.05] mix-blend-overlay"
        style={{ backgroundImage: GRAIN }}
    />
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let raf;
        const loop = (time) => {
            lenis.raf(time);
            raf = requestAnimationFrame(loop);
        };
        raf = requestAnimationFrame(loop);

        const onClick = (e) => {
            const a = e.target.closest && e.target.closest('a[href^="#"]');
            if (!a) return;
            const href = a.getAttribute("href");
            if (href && href.length > 1) {
                const el = document.querySelector(href);
                if (el) {
                    e.preventDefault();
                    lenis.scrollTo(el, { offset: -70 });
                }
            }
        };
        document.addEventListener("click", onClick);
        return () => {
            cancelAnimationFrame(raf);
            document.removeEventListener("click", onClick);
            lenis.destroy();
        };
    }, []);

    return (
        <div className="relative min-h-screen overflow-x-clip bg-maroon-950 text-cream">
            <Grain />
            <Nav />
            <main>
                <Hero />
                <Marquee />
                <Categories />
                <Pillars />
                <Visit />
            </main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}

export default App;